import {
    Box,
    Typography,
} from "@mui/material";
import { FC } from "react";
import PageContainer from "../../components/pageContainer";
import { grey } from '@mui/material/colors';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

export type NotFoundProps = {};

const NotFound: FC = () => {

    return (
        <PageContainer>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
                <HelpOutlineOutlinedIcon sx={{ fontSize: 150, color: grey[500], mb: 2 }} />
                <Typography variant="h5" component="div" mb={2} color={grey[500]}>
                    ページが見つかりません
                </Typography>
            </Box>
        </PageContainer>
    );
};

export default NotFound;
